import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { OccupancyStoreEffects } from './occupancy.effects';
import { dashboardOccupancyStoreFeatureKey, reducer } from './occupancy.reducers';

export function provideOccupancyStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardOccupancyStoreFeatureKey, reducer),
    provideEffects([OccupancyStoreEffects]),
  ]);
}
